import React from 'react';

import { HrStyled } from './Styled';

const Hr = React.memo(({ noMargin }: any) => <HrStyled className={noMargin ? 'not-margin' : ''} />);

export default Hr;
export { Hr };
